import * as React from 'react';

import { ComparisonControlContainer } from './ComparisonControlContainer';
import { ComplainControlContainer } from './ComplainControlContainer';
import * as styles from './ControlsContainer.css';
import { DownloadPDFControlContainer } from './DownloadPDFControlContainer';
import { FavoritesControlContainer } from './FavoritesControlContainer';
import { HideOfferControlContainer } from './HideOfferControlContainer';
import { ShowOnMapControlContainer } from './ShowOnMapControlContainer';

// TODO добавить
// import { AddNoteControlContainer } from './AddNoteControlContainer';
// import { RequestCallContainer } from './RequestCallContainer';

export function ControlsContainer() {
  return (
    <div className={styles['wrapper']}>
      <FavoritesControlContainer />
      <ComparisonControlContainer />
      <HideOfferControlContainer />
      <ComplainControlContainer />
      <ShowOnMapControlContainer />
      <DownloadPDFControlContainer />
    </div>
  );
}
